<template>
	<div>
		<vue-headful
				title="¿Qué estudios realizamos?"
				description="Te mostramos todos los estudios que podes realizar en nuestro laboratorio. En VARELAB realizamos más de 2000 tipos de estudios, consultá por otros estudios sin preparación previa."
		/>
		<div class="front front--page">
			<div v-parallax="0.1" v-parallax.centerX class="bg-parallax bg-parallax--estudios"></div>
			<div class="container">
				<h1 class="title title--big color--white">Estudios</h1>
				<div class="separator separator--white"></div>
			</div>
		</div>
		<div class="bg--boston-blue page--studies__search">
			<div class="container">
				<h3 class="color--white">
					Te mostramos todos los estudios que podes realizar en nuestro laboratorio
				</h3>
				<form @submit.prevent="" action="" method="POST" role="form">
					<div class="row">
						<div class="col-sm-8 col-md-9">
							<div class="form-group">
								<input v-model="search" type="text" class="form-control bg--white" id="" placeholder="Nombre del estudio o palabra clave">
							</div>
						</div>
						<div class="col-sm-4 col-md-3">
							<div class="row">
								<div class="col-xs-6 hidden">
									<a href="#" @click.prevent="search = ''" class="button button--blue-transparent text-uppercase block radius-10">Todos</a>
								</div>
								<div class="col-xs-6 hidden">
									<button class="button button--blue radius-10 text-uppercase block">Buscar</button>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
		<div class="page-body page--studies__list">
			<div class="container">
				<h2 v-if="search">Resultados para "{{ search }}"</h2>
				<div class="row m-bottom-30">
						<div class="row-sm-height">
							<div class="col-sm-4 col-sm-height col-top p-top-35 p-bottom-35">
								<div v-for="(study, index) in filteredStudies1" class="page-block">
										<div class="color--blue padding-8 montserrat">
											<h3>{{ study.title }}</h3>
											<div v-if="study.subtitle">
												<b class="text-uppercase">{{ study.subtitle }}</b>									
											</div>
										</div>
										<div class="bg--gray-light open-sans">
											<b data-toggle="collapse" :data-target="'#collapse-1-' + index" class="color--gray block page--studies__collapse pointer collapsed">
												Preparación <span class="text-uppercase color--blue light pull-right open-sans page--studies__show">Ver</span>
											</b>
											<div :id="'collapse-1-' + index" class="collapse">
												<div class="page--studies__content">
													<ul v-if="study.list" class="list no-padding color--gray" v-html="study.list">
													</ul>
													<b class="color--blue font-size-12" v-if="study.notes" v-html="study.notes">
													</b>
												</div>
												<div class="page--studies__footer bg--lighten-blue color--white text-uppercase font-size-12">
													<i>Por favor, cumpla con la preparación solicitada, es <b>indispensable</b> para el resultado del análisis</i>
												</div>
											</div>
										</div>       
								</div>
							</div>
							<div class="col-sm-4 col-sm-height col-top p-top-35 p-bottom-35">
								<div v-for="(study, index) in filteredStudies2" class="page-block">
										<div class="color--blue padding-8 montserrat">
											<h3>{{ study.title }}</h3>
											<div v-if="study.subtitle">
												<b class="text-uppercase">{{ study.subtitle }}</b>									
											</div>
										</div>
										<div class="bg--gray-light open-sans">
											<b data-toggle="collapse" :data-target="'#collapse-2-' + index" class="color--gray block page--studies__collapse pointer collapsed">
												Preparación <span class="text-uppercase color--blue light pull-right open-sans page--studies__show">Ver</span>
											</b>
											<div :id="'collapse-2-' + index" class="collapse">
												<div class="page--studies__content">
													<ul v-if="study.list" class="list no-padding color--gray" v-html="study.list">
													</ul>
													<b class="color--blue font-size-12" v-if="study.notes" v-html="study.notes">
													</b>
												</div>
												<div class="page--studies__footer bg--lighten-blue color--white text-uppercase font-size-12">
													<i>Por favor, cumpla con la preparación solicitada, es <b>indispensable</b> para el resultado del análisis</i>
												</div>
											</div>
										</div>       
								</div>
							</div>
							<div class="col-sm-4 col-sm-height col-top p-top-35 p-bottom-35">
								<div v-for="(study, index) in filteredStudies3" class="page-block">
										<div class="color--blue padding-8 montserrat">
											<h3>{{ study.title }}</h3>
											<div v-if="study.subtitle">
												<b class="text-uppercase">{{ study.subtitle }}</b>									
											</div>
										</div>
										<div class="bg--gray-light open-sans">
											<b data-toggle="collapse" :data-target="'#collapse-3-' + index" class="color--gray block page--studies__collapse pointer collapsed">
												Preparación <span class="text-uppercase color--blue light pull-right open-sans page--studies__show">Ver</span>
											</b>
											<div :id="'collapse-3-' + index" class="collapse">
												<div class="page--studies__content">
													<ul v-if="study.list" class="list no-padding color--gray" v-html="study.list">
													</ul>
													<b class="color--blue font-size-12" v-if="study.notes" v-html="study.notes">
													</b>
												</div>
												<div class="page--studies__footer bg--lighten-blue color--white text-uppercase font-size-12">
													<i>Por favor, cumpla con la preparación solicitada, es <b>indispensable</b> para el resultado del análisis</i>
												</div>
											</div>
										</div>       
								</div>
							</div>
						</div>
				</div>
				<h3 class="color--light-blue">
					En VARELAB realizamos más de 2000 tipos de estudios, consultá por otros estudios sin preparación previa. 
				</h3>
			</div>
		</div>
	</div>
</template>

<script>

import ListaEstudios from '../../assets/estudios.json';

export default {
	name: 'estudios',
	data() {
		return {
			search: '',
			studies: ListaEstudios
		}
	},
	created() {
	},
	computed: {
		filteredStudies1: function() {
			return this.studies.seccion1.filter((study) => {
				return study.title.toLowerCase().indexOf(this.search.toLowerCase())>=0 || study.list.toLowerCase().indexOf(this.search.toLowerCase())>=0;
			});
		},
		filteredStudies2: function() {
			return this.studies.seccion2.filter((study) => {
				return study.title.toLowerCase().indexOf(this.search.toLowerCase())>=0 || study.list.toLowerCase().indexOf(this.search.toLowerCase())>=0;
			});
		},
		filteredStudies3: function() {
			return this.studies.seccion3.filter((study) => {
				return study.title.toLowerCase().indexOf(this.search.toLowerCase())>=0 || study.list.toLowerCase().indexOf(this.search.toLowerCase())>=0;
			});
		}
	},
	methods: {
		toggle: function (clicked) {
			clicked = !clicked
		}
	}
}
</script>
<!-- styling for the component -->
<style>

</style>


// WEBPACK FOOTER //
// src/components/Servicios/Estudios.vue